import { render, staticRenderFns } from "./GroupRow.vue?vue&type=template&id=095b60dc&scoped=true&"
import script from "./GroupRow.vue?vue&type=script&lang=ts&"
export * from "./GroupRow.vue?vue&type=script&lang=ts&"
import style0 from "./GroupRow.vue?vue&type=style&index=0&id=095b60dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095b60dc",
  null
  
)

export default component.exports